///////////////////////////////////////////////////////////////////
//////////Running Code::::::::::///////////////
///////////////////////////////////////////////////////////////////

import axios from "axios";
import { config, config2, config3 } from "./config";
import { interactionType } from "./../Redux/actionType/actionType";
import toast from "react-hot-toast";
import { actionType } from "./../Redux/actionType/actionType";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

let FACE_CHANGE_SUCCESS,
  FACECHK_URL_NOTFOUND,
  SIGNUP2_API_NOT_WORKING,
  EMPFACE_NOT_MATCH,
  FACE_REG_API_NOT_WORKING,
  FRM_OFF,
  ADMIN_FRM_NOT_WORKING,
  FACE_NOT_MATCHED,
  MULTIPLE_FACES,
  DIFF_EMP,
  ADMIN_FRM_ERROR,
  ACCURACY_HIGH,
  SITE_LOC_NOT_FETCHED;

let ATTENDANCE_MARKED, FACE_MATCHED, FACECHECK_OFF_ATT_MARKED, FRM_OFF_ATT_DONE;

if (window.env) {
  //Error Handling
  //Face Register
  FACECHK_URL_NOTFOUND = window.env.ERROR.FACECHK_URL_NOTFOUND;
  SIGNUP2_API_NOT_WORKING = window.env.ERROR.SIGNUP2_API_NOT_WORKING;
  EMPFACE_NOT_MATCH = window.env.ERROR.EMPFACE_NOT_MATCH;
  FACE_REG_API_NOT_WORKING = window.env.ERROR.FACE_REG_API_NOT_WORKING;
  FRM_OFF = window.env.ERROR.FRM_OFF;
  ADMIN_FRM_NOT_WORKING = window.env.ERROR.ADMIN_FRM_NOT_WORKING;
  FACE_NOT_MATCHED = window.env.ERROR.FACE_NOT_MATCHED;
  MULTIPLE_FACES = window.env.ERROR.MULTIPLE_FACES;
  DIFF_EMP = window.env.ERROR.DIFF_EMP;
  ADMIN_FRM_ERROR = window.env.ERROR.ADMIN_FRM_ERROR;
  ACCURACY_HIGH = window.env.ERROR.ACCURACY_HIGH;
  SITE_LOC_NOT_FETCHED = window.env.ERROR.SITE_LOC_NOT_FETCHED;

  //Success Handing
  ATTENDANCE_MARKED = window.env.SUCCESS.ATTENDANCE_MARKED;
  FACE_CHANGE_SUCCESS = window.env.SUCCESS.FACE_CHANGE_SUCCESS;
  FACE_MATCHED = window.env.SUCCESS.FACE_MATCHED;
  FACECHECK_OFF_ATT_MARKED = window.env.SUCCESS.FACECHECK_OFF_ATT_MARKED;
  FRM_OFF_ATT_DONE = window.env.SUCCESS.FRM_OFF_ATT_DONE;
} else {
  toast("Problem in getting env file", {
    duration: 4500,
    icon: "❗",
  });
}

//For Password
export const passwordAPI = (oldPass, newPass, userID, empID, token) => {
  let data = new FormData();

  data.append("cmd", "PS_CHG");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("oldPassword", oldPass.toString());
  data.append("newPassword", newPass.toString());

  return axios.request(config(data));
};

//For Login
export const loginAuth = (userID, password) => {
  let data = new FormData();
  data.append("cmd", "SignIn");
  data.append("userid", userID.toUpperCase());
  data.append("password", password);
  

  return axios.request(config(data));
};

//For Fetching Location
 export const getLocation = (userID, empID, token) => {
  let data = new FormData();
  data.append("cmd", "SiteList");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios.request(config(data));
};



//For Fetching AdminFRM
export const adminFRM = (userID, empID, token) => {
  let data = new FormData();
  data.append("cmd", "AdminFRM");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("version", "G1");
  //data.append("mac_id",mac_id);
  


  return axios.request(config(data));
};

//For Checking Face
export const faceCheck = (url, apiKey) => {
  let error = "Face Check Failed, Invalid URL!";
  if (!url) {
    toast(FACECHK_URL_NOTFOUND, {
      icon: "❗",
      duration: 4500,
    });
    return;
  }
  const photo = localStorage.getItem("Photo");
  let data = new FormData();

  //data.append("url1", url);
  data.append("url1", "https://frs.ncrtc.in/");
  data.append("data", photo);
  //data.append("APIKEY", apiKey);
  data.append("APIKEY", 'ef44597f-3367-4218-ac91-5fb86b2cc780');
  //data.append("mac_id",mac_id);
  

  return axios.request(config2(data));
};

//Check In
export const checkIn = (
  cmd,
  userID,
  empID,
  token,
  photo,
  latlong,
  location,
  distance,
  accuracy,
  mac_id,
  user_site
) => {
  let data = new FormData();

  if (distance === 0) {
    distance = "0.001";
  }
  distance = Math.ceil(distance);

  data.append("cmd", cmd);
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("photo", photo);
  data.append("latlong", latlong);
  data.append("location", location);
  data.append("distance", distance);
  data.append("version", "G1");
  data.append("accuracy", accuracy);
  data.append("user_site", user_site);
  data.append("mac_id",mac_id);        //when we append this place then mac_id show into the payload.
  //data.append("mac_id",setDeviceId); 
  

  return axios.request(config(data));
};

//For Fetching Attendance
export const fetchAttendance = (userID, empID, token, dateFrom, dateUpto) => {
  const data = new FormData();
  data.append("userid", userID);
  data.append("cmd", "LogDetailsNew");
  data.append("empid", empID);
  data.append("token", token);
  data.append("dtFrom", dateFrom);
  data.append("dtUpto", dateUpto);
  
  return axios(config(data));
};

//For CheckIn CheckOut
export const checkInTime = (
  //mac_id,
  cmd,
  userID,
  empID,
  token,
  photo,
  latlong,
  location,
  distance,
  accuracy,
  mac_id,
  user_site,
 
) => {
  return async (dispatch) => {
    //First We Check admin FRM returns ON or OFF
    try {
      const response = await adminFRM(userID, empID, token);

      if (response && response.status === 200 && response.data.FRM === "ON") {
        //If Data FRM returns Yes
        const url = response.data.IP;
        const apiKey = response.data.APIKEY;

        try {
          const response2 = await faceCheck(url, apiKey);

          //Then Face recognition starts
          if (parseInt(response2.data.code) === 28) {
            //Face Not Matched or Not able to detect
            toast(FACE_NOT_MATCHED, {
              icon: "❗",
              duration: 4500,
            });

            if (cmd === "CheckIn") {
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            } else if (cmd === "CheckOut") {
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }

            return false;
          }
          if (response2.data.result.length > 1) {
            //If Multiple Faces detected
            toast(MULTIPLE_FACES, {
              icon: "❗",
              duration: 4500,
            });
            if (cmd === "CheckIn") {
              dispatch({
                type: actionType.CLOSE_CHECKIN, 
                payload: false,
              });
            } else if (cmd === "CheckOut") {
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
            return false;
          }
          if (response2.data.result[0].subjects[0].subject !== empID) {
            //Face matches SomeOther employee
            toast(
              `${DIFF_EMP} ${response2.data.result[0].subjects[0].subject}`,
              {
                icon: "❗",
                duration: 4500,
              }
            );
            if (cmd === "CheckIn") {
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            } else if (cmd === "CheckOut") {
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }

            return false;
          }
          if (
            response2.data.result[0].subjects[0].subject === empID &&
            parseFloat(response2.data.result[0].subjects[0].similarity) >= 0.2
          ) {
            //Face matches
            try {
              const response3 = await checkIn(
                //mac_id,
                cmd,
                userID,
                empID,
                token,
                photo,
                latlong,
                location,
                distance,
                accuracy,
                mac_id,
                user_site
              );
              if (response3.data.response === "OK") {
                toast.success(ATTENDANCE_MARKED, {
                  duration: 3000,
                });
                toast.success(FACE_MATCHED, {
                  duration: 3000,
                });

                if (cmd === "CheckIn") {
                  dispatch({
                    type: actionType.CLOSE_CHECKIN,
                    payload: false,
                  });
                } else if (cmd === "CheckOut") {
                  dispatch({
                    type: actionType.CLOSE_CHECKOUT,
                    payload: false,
                  });
                }
              }
            } catch (error) {
              toast.error(error.message);
            }
          }
        } catch (error) {
          //Incase Face Check Not Working
          try {
            const response4 = await checkIn(
              //mac_id,
              cmd,
              userID,
              empID,
              token,
              photo,
              latlong,
              location,
              distance,
              accuracy,
              mac_id,
              user_site
            );
            if (response4.data.response === "OK") {
              toast.success(FACECHECK_OFF_ATT_MARKED, {
                duration: 5000,
              });
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            }
          } catch (error) {}
        }
      } else if (
        response &&
        response.status === 200 &&
        response.data.FRM === "OFF"
      ) {
        try {
          const response = await checkIn(
            //mac_id,
            cmd,
            userID,
            empID,
            token,
            photo,
            latlong,
            location,           
            distance,
            accuracy,
            mac_id,
            user_site
          );
          if (response.data.response === "OK") {
            toast.success(FRM_OFF_ATT_DONE, {
              duration: 5000,
            });
            if (cmd === "CheckIn") {
              dispatch({
                type: actionType.CLOSE_CHECKIN,
                payload: false,
              });
            } else if (cmd === "CheckOut") {
              dispatch({
                type: actionType.CLOSE_CHECKOUT,
                payload: false,
              });
            }
          }
        } catch (error) {}
      }
    } catch (error) {
      toast.error(ADMIN_FRM_ERROR, {
        duration: 3000,
      });
    }
  };
};

/////////////////////////////
//////Running Code:::::::::For fetch location
//////////////////////////////
//For Fetching Location    
export const fetchLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position, error) => {
          let { latitude, longitude, accuracy } = position.coords;

          let lat1 = latitude.toString().substring(0, 7);
          let lon1 = longitude.toString().substring(0, 7);
          let latlong = `${lat1},${lon1}`;
          if (error) {                                                 ////Completely Removed
            reject(new Error("Please Enable Your GeoLocation"));
            return;
          }

          //Function to convert degree to radian
          function deg2rad(deg) {
            return deg * (Math.PI / 180);
          }
          //Haversine Formula function to calculate distance between two points
          function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            lat1 = parseFloat(lat1);
            lon1 = parseFloat(lon1);
            lat2 = parseFloat(lat2);
            lon2 = parseFloat(lon2);
            const R = 6371; // Radius of the earth in km
            const dLat = deg2rad(lat2 - lat1);
            const dLon = deg2rad(lon2 - lon1);
            const a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(deg2rad(lat1)) *
                Math.cos(deg2rad(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const d = R * c; // Distance in km
            return d;
          }

          if (accuracy > 100) {
            resolve({
              longitude,
              latitude,
              accuracy,
              location: "SITE",
              latlong,
              distance2: "1",
            });
            toast(ACCURACY_HIGH, {
              icon: "❗",
              duration: 4500,
            });
            return;
          }

          const site = JSON.parse(localStorage.getItem("location"));
          let isLocation = false;

          if (site === null || site === " ") {
            reject(new Error(SITE_LOC_NOT_FETCHED));
            return;
          }
          let distance2;
          if (site) {
            for (let item in site) {
              const lat2 = site[item].latlong.split(",")[0];
              const lon2 = site[item].latlong.split(",")[1];

              const distance =
                getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) * 1000;

              if (distance < site[item].fence) {
                let location = site[item].location;

                distance2 = distance;
                isLocation = true;
                resolve({
                  lat1,
                  lon1,
                  accuracy,
                  location,
                  latlong,
                  distance2,
                });

                break;   //////i thik issues is here
              }
            }

            if (!isLocation) {
              let location = "SITE";
              resolve({
                lat1,
                lon1,
                accuracy,
                location,
                latlong,
                distance2: "1",
              });
            }
          }
        },
        (error) => {
          reject(
            new Error("Please turn on your GPS and allow Location permission")
          );
        },
        {
          enableHighAccuracy: true,
          timeout: 12000,
          maximumAge: 0,
        }
      );
    } else {
      reject(new Error("Geolocation is not supported by this browser."));
    }
  });
};

///////////////////////////01Jan@026 Testing code....For fetch nearest Location (it is working code 14Feb2026 but not deployed...due to shifting on CLoud.)
// export const fetchLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (!navigator.geolocation) {
//       reject(new Error("Geolocation is not supported by this browser."));
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (position) => {                                                    /////here logic chnaged
//         const { latitude, longitude, accuracy } = position.coords;

//         // Full precision (used for calculations)
//         const currentLat = latitude;
//         const currentLon = longitude;
        

//         // Truncated values (used only for display/storage)
//         const lat1 = latitude.toString().substring(0, 7);
//         const lon1 = longitude.toString().substring(0, 7);
//         const latlong = `${lat1},${lon1}`;

//         // Degree to radian
//         const deg2rad = (deg) => deg * (Math.PI / 180);

//         // Haversine formula
//         const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
//           lat1 = parseFloat(lat1);
//           lon1 = parseFloat(lon1);
//           lat2 = parseFloat(lat2);
//           lon2 = parseFloat(lon2);

//           const R = 6371; // Earth radius in km
//           const dLat = deg2rad(lat2 - lat1);
//           const dLon = deg2rad(lon2 - lon1);

//           const a =
//             Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//             Math.cos(deg2rad(lat1)) *
//               Math.cos(deg2rad(lat2)) *
//               Math.sin(dLon / 2) *
//               Math.sin(dLon / 2);

//           const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//           return R * c;
//         };

//         // Accuracy check
//         if (accuracy > 100) {
//           toast(ACCURACY_HIGH, {
//             icon: "❗",
//             duration: 4500,
//           });

//           resolve({
//             latitude,
//             longitude,
//             accuracy,
//             location: "SITE",
//             latlong,
//             distance2: "1",
//           });
//           return;
//         }

//         const site = JSON.parse(localStorage.getItem("location"));

//         if (!site || site === " ") {
//           reject(new Error(SITE_LOC_NOT_FETCHED));
//           return;
//         }

//         let nearestSite = null;        //chnage
//         let minDistance = Infinity;   //change

//         // Find nearest overlapping geofence
//         for (let item in site) {
//           const [lat2, lon2] = site[item].latlong.split(",");

//           const distance =
//             getDistanceFromLatLonInKm(
//               currentLat,
//               currentLon,
//               lat2,
//               lon2
//             ) * 1000; // meters

//           if (
//             distance <= site[item].fence &&
//             distance < minDistance
//           ) {
//             minDistance = distance;
//             nearestSite = site[item];  //chnage
//           }
//         }

//         // Final decision
//         if (nearestSite) {
//           resolve({
//             lat1,
//             lon1,
//             accuracy,
//             location: nearestSite.location,  //chnage
//             latlong,
//             distance2: minDistance,
//           });
//         } else {
//           resolve({
//             lat1,
//             lon1,
//             accuracy,
//             location: "SITE",
//             latlong,
//             distance2: "1",
//           });
//         }
//       },
//       () => {
//         reject(
//           new Error(
//             "Please turn on your GPS and allow Location permission"
//           )
//         );
//       },
//       {
//         enableHighAccuracy: true,
//         timeout: 12000,
//         maximumAge: 0,
//       }
//     );
//   });
// };
// fetchLocation().then((res) => {
//   console.table(res);
// });
/////////////////For testing of overlap latlong to fetching the nearest one into the console:::
// window.fetchLocation = fetchLocation;
///////////////////////////////////////////For testing Alert messages...:::::::::::::::::
// export const fetchLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (!navigator.geolocation) {
//       reject(new Error("Geolocation is not supported by this browser."));
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const { latitude, longitude, accuracy } = position.coords;

//         /* ============================
//            1️⃣ ALERT: CURRENT LOCATION
//         ============================ */
//         alert(
//           `📍 Your Current Location\n\n` +
//           `Latitude: ${latitude}\n` +
//           `Longitude: ${longitude}\n` +
//           `Accuracy: ${accuracy} meters`
//         );

//         const currentLat = latitude;
//         const currentLon = longitude;

//         const lat1 = latitude.toString().substring(0, 7);
//         const lon1 = longitude.toString().substring(0, 7);
//         const latlong = `${lat1},${lon1}`;

//         const deg2rad = (deg) => deg * (Math.PI / 180);

//         const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
//           lat1 = parseFloat(lat1);
//           lon1 = parseFloat(lon1);
//           lat2 = parseFloat(lat2);
//           lon2 = parseFloat(lon2);

//           const R = 6371;
//           const dLat = deg2rad(lat2 - lat1);
//           const dLon = deg2rad(lon2 - lon1);

//           const a =
//             Math.sin(dLat / 2) ** 2 +
//             Math.cos(deg2rad(lat1)) *
//               Math.cos(deg2rad(lat2)) *
//               Math.sin(dLon / 2) ** 2;

//           const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//           return R * c;
//         };

//         if (accuracy > 100) {
//           alert("⚠️ GPS accuracy is low. Please move to open area.");

//           resolve({
//             latitude,
//             longitude,
//             accuracy,
//             location: "SITE",
//             latlong,
//             distance2: 0,
//           });
//           return;
//         }

//         const site = JSON.parse(localStorage.getItem("location"));

//         if (!site || site.length === 0) {
//           reject(new Error("Site locations not found"));
//           return;
//         }

//         // Calculate distances for all sites
//         const sitesWithDistance = site.map((item) => {
//           const [lat2, lon2] = item.latlong.split(",");
//           const distance = getDistanceFromLatLonInKm(
//             currentLat,
//             currentLon,
//             lat2,
//             lon2
//           ) * 1000; // in meters
//           return { ...item, distance };
//         });

//         // Sort by distance ascending
//         sitesWithDistance.sort((a, b) => a.distance - b.distance);

//         // Alert the first 3 nearest sites
//         const nearest3 = sitesWithDistance.slice(0, 3);
//         nearest3.forEach((site, index) => {
//           alert(
//             `🏢 Nearest Site #${index + 1}\n\n` +
//             `Site Name: ${site.location}\n` +
//             `Site LatLong: ${site.latlong}\n` +
//             `Distance: ${site.distance.toFixed(2)} meters`
//           );
//         });

//         // Resolve with the nearest site (first one)
//         resolve({
//           lat1,
//           lon1,
//           accuracy,
//           location: nearest3[0]?.location || "SITE",
//           latlong,
//           distance2: nearest3[0]?.distance || 0,
//         });
//       },
//       () => {
//         reject(new Error("Please turn on GPS and allow location permission"));
//       },
//       {
//         enableHighAccuracy: true,
//         timeout: 12000,
//         maximumAge: 0,
//       }
//     );
//   });
// };

// fetchLocation().then((res) => console.table(res));

///////////////////////////////////-----------------------------------------//////////////////////////////


// //Verifies Token and returns Match or Bad Token
export const tokenVerify = (userID, empID, token) => {
  let data = new FormData();
  data.append("cmd", "TokenVerify");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};

//For Changing Face
export const changeFace = (userID, empID, token, photo) => {
  return async (dispatch) => {
    try {
      const response = await adminFRM(userID, empID, token);

      //To check what does admin FRM return ON or OFF
      if (response.data.FRM === "ON") {
        try {
          const data = new FormData();
          data.append("data", photo);
          data.append("empid", empID);
          // data.append("url1", response.data.IP);
          // data.append("APIKEY", response.data.APIKEY);
          data.append("url1", "https://frs.ncrtc.in/");
          data.append("APIKEY", 'ef44597f-3367-4218-ac91-5fb86b2cc780');

          //To Check whether the Registered Face matches the employee Face or not
          const checkAPI = await axios(config3(data));
          if (checkAPI.data.subject === empID) {
            try {
              let data = new FormData();
              data.append("cmd", "SignUp2");
              data.append("userid", userID);
              data.append("empid", empID);
              data.append("token", token);
              data.append("front", photo);

              const response3 = await axios.request(config(data));

              if (response3.data.response === "OK") {
                toast.success(FACE_CHANGE_SUCCESS);
                dispatch({
                  type: interactionType.PHOTO_CHANGE,
                  payload: true,
                });
              }
            } catch (error) {
              //If SignUp2 API does not work
              dispatch({
                type: interactionType.PHOTO_CHANGE,
                payload: false,
              });

              toast(SIGNUP2_API_NOT_WORKING, {
                icon: "❗",
                duration: 4500,
              });
            }
          } else {
            //If employee face does not match
            dispatch({
              type: interactionType.PHOTO_CHANGE,
              payload: false,
            });
            toast(EMPFACE_NOT_MATCH, {
              icon: "❗",
              duration: 4500,
            });
          }
        } catch (error) {
          //If Face Registration API is not working
          dispatch({
            type: interactionType.PHOTO_CHANGE,
            payload: false,
          });
          toast(FACE_REG_API_NOT_WORKING, {
            icon: "❗",
            duration: 4500,
          });
        }
      } else {
        dispatch({
          type: interactionType.PHOTO_CHANGE,
          payload: false,
        });
        toast(FRM_OFF, {
          icon: "❗",
          duration: 4500,
        });
      }
    } catch (error) {
      dispatch({
        type: interactionType.PHOTO_CHANGE,
        payload: false,
      });
      toast(ADMIN_FRM_NOT_WORKING, {
        icon: "❗",
        duration: 4500,
      });
    }
  };
};

//Wallet History
export const walletHistory = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "VIEW_WALLET");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  //data.append("trans_date",trans_date);

  return axios(config(data));
};

//Canteen Pay
export const canteenPay = (userID, empID, token, amount, remark) => {
  const data = new FormData();
  data.append("cmd", "ADD_TO_WALLET");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("dr_amt", amount);
  data.append("remark", remark);
  

  return axios(config(data));
};

//Canteen Menu
export const canteenMenu = (userID, empID, token, company) => {
  const data = new FormData();
  data.append("cmd", "MENU_LIST");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("off_loc", "");
  return axios(config(data));
};

export const canteenFeedback = (userID, empID, token, token_no, rating, remarks) => {

  const data = new FormData();
  data.append("cmd", "CANTEEN_FEEDBACK");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("token_no", token_no);
  data.append("rating", rating);
  data.append("remarks", remarks);
  //data.append("trans_date", trans_date);
  
  return axios(config(data));
}

// export const hospitallist = (cmd,userID, empID, token, hosp_type) => {
//    const data = new FormData();
//    data.append("cmd", cmd);
//    data.append("userid", userID);
//    data.append("empid", empID);
//    data.append("token", token);
//    data.append("hosp_type", hosp_type);
//    //data.append("LABS",LABS);
   
   
//   return axios(config(data));

  
// }

////////////////////////Testing code  for hospitallist:::
export const hospitallist = (cmd, userID, empID, token, hosp_type = '', extraFields = {}) => {
  const data = new FormData();
  data.append("cmd", cmd);
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  if (hosp_type) data.append("hosp_type", hosp_type);

  // ✅ Append any extra fields like hosp_nm
  Object.keys(extraFields).forEach(key => {
    data.append(key, extraFields[key]);
  });

  return axios(config(data));
};



//Manual Attendance
export const manualAttendance = (
  userID,
  empID,
  token,
  date,
  inTime,
  inFrom,
  outTime,
  outFrom,
  remarkVal
) => {
  const data = new FormData();
  data.append("cmd", "MN_ATT");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("dt", date);
  data.append("in_time", inTime);
  data.append("in_from", inFrom);
  data.append("out_time", outTime);
  data.append("out_from", outFrom);
  data.append("remarks", remarkVal);
  data.append("auth_seq", 1);

  return axios(config(data));
};

// Manual Attendance List
export const manualAttendanceList = (userID, empID, token, status_type) => {
  const data = new FormData();
  data.append("cmd", "LS_MN_ATT");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("status", status_type);

  return axios(config(data));
};

//To show List of Manual Attendance List to Reporting Officer
export const manualAttendanceTableList = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "PN_MN_ATT_DET");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};

//To Approve Manual Attendance
export const approveManualAttendance = (userID, empID, token, punch_id) => {
  const data = new FormData();
  data.append("cmd", "AP_MN_ATT");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("act", "A");
  data.append("punch_id", punch_id);

  return axios(config(data));
};

//To Reject Manual Attendance
export const rejectManualAttendance = (userID, empID, token, punch_id) => {
  const data = new FormData();
  data.append("cmd", "AP_MN_ATT");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("act", "R");
  data.append("punch_id", punch_id);

  return axios(config(data));
};

//Password Change
export const changePassword = (userID, empID, token, oldPass, newPass) => {
  const data = new FormData();
  data.append("cmd", "PS_CHG");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("oldPassword", oldPass.toString());
  data.append("newPassword", newPass.toString());

  return axios(config(data));
};

//LeaveBalance
export const leaveBalance = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "BAL_LEAVES");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};


////LeaveBalance
export const pendingLeaves = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "GET_LEAVES");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};

//Restricted Holiday Leaves
export const restrictedHoliday = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "RH_LIST");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};

//Sanction Officer
export const sanctionOfficer = (userID, empID, token, leaveType, days) => {
  const data = new FormData();
  data.append("cmd", "SN_LEAVE");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("leave_type", leaveType);
  data.append("days", days);

  return axios(config(data));
};

//Sanction Officer
export const applyLeaves = (
  userID,
  empID,
  token,
  leaveType,
  dateFrom,
  sessionFrom,
  dateTo,
  sessionTo,
  noDays,
  boss,
  sanctionBoss,
  location,
  remarks
) => {
  const data = new FormData();
  data.append("cmd", "CR_LEAVE");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("leave_type", leaveType);
  data.append("date_from", dateFrom);
  data.append("date_to", dateTo);
  data.append("session_from", sessionFrom);
  data.append("session_to", sessionTo);
  data.append("days", noDays);
  data.append("boss", boss);
  data.append("sanction_by", sanctionBoss);
  data.append("location", location);
  data.append("remarks", remarks);

  return axios(config(data));
};

//to show Pending Leave Details
export const pendingLeavesApprovals = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "PN_LEAVE_DET");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};

//Approve Reject Leave
export const approveRejectLeave = (userID, empID, token, id, act) => {
  const data = new FormData();
  data.append("cmd", "AP_LEAVE");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);
  data.append("id", id);
  data.append("act", act);

  return axios(config(data));
};

//Employee Directory
export const empDir = (userID, empID, token) => {
  const data = new FormData();
  data.append("cmd", "EMP_DIRECTORY");
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("token", token);

  return axios(config(data));
};
 

//For Team Attendance
export const teamAttendance =(token, userID, empID)=>{
  let data = new FormData();
  data.append("cmd", "mCurrentTeamAttendance");
  data.append("token", token);
  data.append("userid", userID);
  data.append("empid", empID);
  data.append("full",1);
  

  return axios.request(config(data));
}

///////////////////////Testing Code::::

// export const teamAttendance = (token, userID, empID, full = 0) => {
//   let data = new FormData();
//   data.append("cmd", "mCurrentTeamAttendance");
//   data.append("token", token);
//   data.append("userid", userID);
//   data.append("empid", empID);

//   if (full) {
//     data.append("full", 1);
//   }

//   return axios.request(config(data));
// };




// export const fullatt =(token, userID, empID)=>{
//   let data = new FormData();
//   data.append("cmd", "full");
//   data.append("token", token);
//   data.append("userid", userID);
//   data.append("empid", empID);
  

//   return axios.request(config(data));
// };



/////////////////////////////////////////////////////////////////////////////////////////////

//////////Testing code for fetch locations::::::::::::::::::::
////////////////////////////////////////////////////////////////
// export const fetchLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position, error) => {
//           let { latitude, longitude, accuracy } = position.coords;

//           let lat1 = latitude.toString().substring(0, 7);
//           let lon1 = longitude.toString().substring(0, 7);
//           let latlong = `${lat1},${lon1}`;
//           if (error) {
//             reject(new Error("Please Enable Your GeoLocation"));
//             return;
//           }

//           //Function to convert degree to radian
//           function deg2rad(deg) {
//             return deg * (Math.PI / 180);
//           }

//           //Haversine Formula function to calculate distance between two points
//           function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
//             lat1 = parseFloat(lat1);
//             lon1 = parseFloat(lon1);
//             lat2 = parseFloat(lat2);
//             lon2 = parseFloat(lon2);
//             const R = 6371; // Radius of the earth in km
//             const dLat = deg2rad(lat2 - lat1);
//             const dLon = deg2rad(lon2 - lon1);
//             const a =
//               Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//               Math.cos(deg2rad(lat1)) *
//                 Math.cos(deg2rad(lat2)) *
//                 Math.sin(dLon / 2) *
//                 Math.sin(dLon / 2);
//             const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//             const d = R * c; // Distance in km
//             return d;
//           }

//           if (accuracy > 100) {
//             resolve({
//               longitude,
//               latitude,
//               accuracy,
//               location: "SITE",
//               latlong,
//               distance2: "1",
//             });
//             toast(ACCURACY_HIGH, {
//               icon: "❗",
//               duration: 4500,
//             });
//             return;
//           }

//           const site = JSON.parse(localStorage.getItem("location"));
//           let isLocation = false;

//           if (site === null || site === " ") {
//             reject(new Error(SITE_LOC_NOT_FETCHED));
//             return;
//           }

//           let distance2;
//           if (site) {
//             for (let item in site) {
//               const lat2 = site[item].latlong.split(",")[0];
//               const lon2 = site[item].latlong.split(",")[1];

//               const distance =
//                 getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) * 1000;

//               if (distance < site[item].fence) {
//                 let location = site[item].location;

//                 distance2 = distance;
//                 isLocation = true;
//                 resolve({
//                   lat1,
//                   lon1,
//                   accuracy,
//                   location,
//                   latlong,
//                   distance2,
//                 });

//                 break;
//               }
//             }

//             if (!isLocation) {
//               let location = "SITE";
//               resolve({
//                 lat1,
//                 lon1,
//                 accuracy,
//                 location,
//                 latlong,
//                 distance2: "1",
//               });
//             }
//           }

//           // Deleting fetchedLoc from localStorage
//           localStorage.removeItem("fetchedLoc");

//         },
//         (error) => {
//           reject(
//             new Error("Please turn on your GPS and allow Location permission")
//           );
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 12000,
//           maximumAge: 0,
//         }
//       );
//     } else {
//       reject(new Error("Geolocation is not supported by this browser."));
//     }
//   });
// };

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ///////////Updated testing code but some issues occurs:::::
////////////////////////////////////////////////////////////////////////////////////////////////////////////
// export const fetchLocation = () => {
//   return new Promise((resolve, reject) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           // Get latitude, longitude, and accuracy
//           let { latitude, longitude, accuracy } = position.coords;
//           let lat1 = latitude.toString().substring(0, 7);
//           let lon1 = longitude.toString().substring(0, 7);
//           let latlong = `${lat1},${lon1}`;

//           // Function to convert degree to radian
//           function deg2rad(deg) {
//             return deg * (Math.PI / 180);
//           }

//           // Haversine Formula function to calculate distance between two points
//           function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
//             lat1 = parseFloat(lat1);
//             lon1 = parseFloat(lon1);
//             lat2 = parseFloat(lat2);
//             lon2 = parseFloat(lon2);
//             const R = 6371; // Radius of the earth in km
//             const dLat = deg2rad(lat2 - lat1);
//             const dLon = deg2rad(lon2 - lon1);
//             const a =
//               Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//               Math.cos(deg2rad(lat1)) *
//                 Math.cos(deg2rad(lat2)) *
//                 Math.sin(dLon / 2) *
//                 Math.sin(dLon / 2);
//             const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//             const d = R * c; // Distance in km
//             return d;
//           }

//           if (accuracy > 100) {
//             // If accuracy is poor, resolve with SITE location
//             resolve({
//               longitude,
//               latitude,
//               accuracy,
//               location: "SITE",
//               latlong,
//               distance2: "1",
//             });
//             toast(ACCURACY_HIGH, {
//               icon: "❗",
//               duration: 4500,
//             });
//             return;
//           }

//           const site = JSON.parse(localStorage.getItem("location"));
//           let isLocation = false;

//           // If no location data is found in localStorage, reject
//           if (!site) {
//             reject(new Error("Location not found in localStorage."));
//             // Ensure no previous location is used if not found
//             localStorage.removeItem("location");
//             localStorage.removeItem("fetchedLoc");
//             return;
//           }

//           let distance2;
//           if (site) {
//             for (let item in site) {
//               const lat2 = site[item].latlong.split(",")[0];
//               const lon2 = site[item].latlong.split(",")[1];

//               const distance =
//                 getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) * 1000;

//               if (distance < site[item].fence) {
//                 let location = site[item].location;

//                 distance2 = distance;
//                 isLocation = true;
//                 resolve({
//                   lat1,
//                   lon1,
//                   accuracy,
//                   location,
//                   latlong,
//                   distance2,
//                 });

//                 break;
//               }
//             }

//             // If location doesn't match, resolve as "SITE"
//             if (!isLocation) {
//               let location = "SITE";
//               resolve({
//                 lat1,
//                 lon1,
//                 accuracy,
//                 location,
//                 latlong,
//                 distance2: "1",
//               });
//             }
//           }

//           // Clear previous location data if we successfully get new location data
//           localStorage.removeItem("fetchedLoc");

//         },
//         (error) => {
//           // Handle location permission error or failure to fetch location
//           reject(new Error("Please turn on your GPS and allow Location permission"));

//           // Remove location data from localStorage if geolocation is unavailable or permission is denied
//           localStorage.removeItem("location");
//           localStorage.removeItem("fetchedLoc"); // Clear fetched location as well

//           // If the geolocation service fails or the user disables it, clear local storage
//           if (error.code === error.PERMISSION_DENIED || error.code === error.POSITION_UNAVAILABLE) {
//             // Permanently remove location data to ensure previous locations are not used
//             localStorage.removeItem("location");
//             localStorage.removeItem("fetchedLoc");
//           }
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 12000,
//           maximumAge: 0,
//         }
//       );
//     } else {
//       // Handle if geolocation is not supported by the browser
//       reject(new Error("Geolocation is not supported by this browser."));
      
//       // Clear any previous location data stored
//       localStorage.removeItem("location");
//       localStorage.removeItem("fetchedLoc");
//     }
//   });
// };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////



/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
